import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetWorkstations } from '@/hooks/useGetWorkstations';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { FormItemWrapper, LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';

export function WorkstationFormItem(): JSX.Element {
	const organizationId: string = Form.useWatch('organization_id');
	const companyId: string = Form.useWatch('company_id');
	const sectorId: string = Form.useWatch('sector_id');
	const lineId: string = Form.useWatch('line_id');

	const { data: workstations = [], isLoading } = useGetWorkstations({
		organization_id: organizationId,
		company_id: companyId,
		sector_id: sectorId,
		line_id: lineId
	});

	const isDisabled = !organizationId || !companyId || !sectorId || !lineId;
	const isShowLoading = !!organizationId && !!companyId && !!lineId && !!sectorId && isLoading;

	return (
		<FormItemWrapper
			name="workstation_id"
			label={<LabelMediumRegular>{I18n.get('Workstation')}</LabelMediumRegular>}
			labelCol={{ span: 24 }}
		>
			<SelectOptions
				allowClear
				loading={isShowLoading}
				disabled={isDisabled}
				options={workstations}
				placeholder={I18n.get('Workstation')}
			/>
		</FormItemWrapper>
	);
}
